import { render, staticRenderFns } from "./Remocao.vue?vue&type=template&id=5ee68b54&"
import script from "./Remocao.vue?vue&type=script&lang=js&"
export * from "./Remocao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports